import { render } from "./HoraLogo.vue?vue&type=template&id=bd724362&scoped=true"
import script from "./HoraLogo.vue?vue&type=script&lang=js"
export * from "./HoraLogo.vue?vue&type=script&lang=js"

import "./HoraLogo.vue?vue&type=style&index=0&id=bd724362&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd724362"]])

export default __exports__